import { render, staticRenderFns } from "./femaleexplain.vue?vue&type=template&id=38e6af7a&scoped=true&"
import script from "./femaleexplain.vue?vue&type=script&lang=js&"
export * from "./femaleexplain.vue?vue&type=script&lang=js&"
import style0 from "./femaleexplain.vue?vue&type=style&index=0&id=38e6af7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e6af7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38e6af7a')) {
      api.createRecord('38e6af7a', component.options)
    } else {
      api.reload('38e6af7a', component.options)
    }
    module.hot.accept("./femaleexplain.vue?vue&type=template&id=38e6af7a&scoped=true&", function () {
      api.rerender('38e6af7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/menopauseovary/femaleexplain.vue"
export default component.exports